import React, { useState, useEffect, useRef, useCallback } from "react";
import { Row, Col, CardHeader, CardBody, Spinner, Alert, Input, Button, Badge, Modal, ModalHeader, ModalBody, ModalFooter, Collapse, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { useSearchParams } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { fetchAuthMe } from "../../api/requests/auth-requests";
import { fetchPaymentHistory, deletePayments, downloadPaymentHistoryExcel, updatePaymentAccounted, bulkUpdateAccounted } from "../../api/requests/payment-requests";
import { fetchCompaniesList } from "../../api/requests/company-requests";
import { fetchAccountsMe } from "../../api/requests/account-requests";
import PaymentRefundModal from "../modals/payment/PaymentRefundModal";
import PaymentReceiptEmailModal from "../modals/payment/PaymentReceiptEmailModal";
import PaymentDetailPanel from "../payment/PaymentDetailPanel";
import { viewPaymentReceipt, downloadPaymentReceiptPdf } from "../payment/paymentReceipt";
import TableCard from "./Paymenttablecard";
import { COLORS, DEFAULT_PAGE_SIZES, PAYMENT_METHOD_GROUPS, PAYMENT_SOURCES } from "./Paymenthistoryconstants";
import { getPaymentHistoryStyles } from "./Paymenthistorystyles";
import { getPaymentWords } from "../../utils/paymentWord";
import {
    formatAmount,
    formatDateTime,
    getPaymentStatusText,
    getCollectionTypeChip,
    getReceiptTypeText,
    getAccountTypeText,
    getPaginationNumbers,
    copyToClipboard,
    statusToChipClass
} from "./Paymenthistoryutils";

import { useNavigate } from "react-router-dom";
import TruncatedText from "../../components/Common/TruncatedText"
import { useAutoRefresh, AUTO_REFRESH_MS } from "../../hooks/useAutoRefresh";
import RefreshIndicator from "../../components/Common/RefreshIndicator";
import DateTimeInput from "../../components/Common/DateTimeInput";

const CollectionTypeChip = ({ payment }) => {
    const chip = getCollectionTypeChip(payment);
    if (!chip) return null;
    return <span className={`chip ${chip.chipClass}`}>{chip.label}</span>;
};

const PaymentHistoryTable = ({ isSessionModalActive }) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(() => parseInt(searchParams.get("page")) || 0);
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const [pageSize, setPageSize] = useState(() => parseInt(searchParams.get("size")) || 10);
    const [searchTerm, setSearchTerm] = useState(() => searchParams.get("searchTerm") || "");
    const [statusFilter, setStatusFilter] = useState(() => searchParams.get("status") || "");
    const [paymentSourceFilter, setPaymentSourceFilter] = useState(() => searchParams.get("paymentSource") || "");
    const [refreshing, setRefreshing] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [pdfLoading, setPdfLoading] = useState({});
    const [copiedId, setCopiedId] = useState(null);
    const [filtersOpen, setFiltersOpen] = useState(() => !!searchParams.get("accountId") || !!searchParams.get("companyId") || !!searchParams.get("status") || !!searchParams.get("receiptType") || !!searchParams.get("paymentSource") || !!searchParams.get("startDate") || !!searchParams.get("endDate") || !!searchParams.get("accounted"));
    const [accounts, setAccounts] = useState([]);
    const [accountFilter, setAccountFilter] = useState(() => searchParams.get("accountId") || "");
    const [currentUser, setCurrentUser] = useState(null);
    const [companies, setCompanies] = useState([]);
    const [companyFilter, setCompanyFilter] = useState(() => searchParams.get("companyId") || "");
    // Kullanıcı Detay → "Ödeme Geçmişi" → /payment-history?userId=<uuid>.
    // Ekranda seçilebilir bir filtre değil; yalnızca URL'den gelir ve isteğe eklenir.
    const userFilter = searchParams.get("userId") || "";
    // Sağdan açılan detay panelinde gösterilen ödeme (null ise panel kapalı)
    const [detailPayment, setDetailPayment] = useState(null);
    const [refundTarget, setRefundTarget] = useState(null);
    const [refundModalOpen, setRefundModalOpen] = useState(false);
    const [emailTarget, setEmailTarget] = useState(null);
    const [emailModalOpen, setEmailModalOpen] = useState(false);
    const [totalSuccessfulAmount, setTotalSuccessfulAmount] = useState(0);
    const [totalPendingAmount, setTotalPendingAmount] = useState(0);
    const [totalFailedAmount, setTotalFailedAmount] = useState(0);
    // Başarılı tahsilatların taksit dağılımı (listeyle aynı filtrelerden gelir).
    const [installmentTransactions, setInstallmentTransactions] = useState(0);
    const [singleTransactions, setSingleTransactions] = useState(0);
    const [selectedPayments, setSelectedPayments] = useState([]);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [deleteSuccess, setDeleteSuccess] = useState(null);
    const [deleteType, setDeleteType] = useState('');
    const [paymentToDelete, setPaymentToDelete] = useState(null);
    const [startDate, setStartDate] = useState(() => searchParams.get("startDate") || "");
    const [endDate, setEndDate] = useState(() => searchParams.get("endDate") || "");
    const isFirstSearch = useRef(true);
    const pdfContentRef = useRef(null);
    const navigate = useNavigate();
    const [receiptTypeFilter, setReceiptTypeFilter] = useState(() => searchParams.get("receiptType") || "");
    const [accountedFilter, setAccountedFilter] = useState(() => searchParams.get("accounted") || "");
    const [accountingLoading, setAccountingLoading] = useState({});

    // Listeye uygulanmış filtrelerin snapshot'ı. Filtre seçildiği anda güncellenir;
    // sayfalama/yenileme/Excel gibi işlemler form state'lerini değil bunu kullanır.
    const [appliedFilters, setAppliedFilters] = useState(() => ({
        searchTerm: searchParams.get("searchTerm") || "",
        status: searchParams.get("status") || "",
        receiptType: searchParams.get("receiptType") || "",
        paymentSource: searchParams.get("paymentSource") || "",
        accountId: searchParams.get("accountId") || "",
        companyId: searchParams.get("companyId") || "",
        startDate: searchParams.get("startDate") || "",
        endDate: searchParams.get("endDate") || "",
        accounted: searchParams.get("accounted") || "",
    }));

    // Formdaki güncel taslak filtreler
    const draftFilters = () => ({
        searchTerm,
        status: statusFilter,
        receiptType: receiptTypeFilter,
        paymentSource: paymentSourceFilter,
        accountId: accountFilter,
        companyId: companyFilter,
        startDate,
        endDate,
        accounted: accountedFilter,
    });

    const EMPTY_FILTERS = {
        searchTerm: "", status: "", receiptType: "", paymentSource: "",
        accountId: "", companyId: "", startDate: "", endDate: "", accounted: "",
    };

    const pw = getPaymentWords(currentUser?.roles);
    document.title = `${pw.Word} Geçmişi | Tahsilat360`;

    // Helper functions
    const isSuperAdmin = () => {
        return currentUser?.roles?.includes("ROLE_SUPER_ADMIN");
    };
    const canToggleAccounted = () => {
        const roles = currentUser?.roles || [];
        return roles.some(r => ["ROLE_SUPER_ADMIN", "ROLE_COMPANY_ADMIN", "ROLE_COMPANY_ACCOUNTANT"].includes(r));
    };
    // İade yetkisi muhasebeleşme ile aynı roller
    const canRefund = () => canToggleAccounted();
    // İade ucu olan sağlayıcılar (PayTR, Garanti, İşyerimPOS) üzerinden geçmiş,
    // başarılı veya kısmen iade edilmiş ödemeler iade edilebilir.
    const REFUNDABLE_VPOS = ["PAYTR", "GARANTI", "ISYERIM_POS"];
    const isRefundable = (p) =>
        (p.status === "SUCCESS" || p.status === "PARTIALLY_REFUNDED") && REFUNDABLE_VPOS.includes(p.virtualPos);
    const handleToggleAccounted = async (payment) => {
        const newValue = !payment.accounted;
        setAccountingLoading(prev => ({ ...prev, [payment.id]: true }));
        try {
            await updatePaymentAccounted(payment.id, newValue);
            setPayments(prev => prev.map(p => p.id === payment.id ? { ...p, accounted: newValue } : p));
        } catch {
            // hata durumunda sessizce bırak
        } finally {
            setAccountingLoading(prev => ({ ...prev, [payment.id]: false }));
        }
    };
    const [bulkAccountingLoading, setBulkAccountingLoading] = useState(false);
    const [exporting, setExporting] = useState(false);
    const handleBulkAccounted = async (accounted) => {
        setBulkAccountingLoading(true);
        try {
            await bulkUpdateAccounted(selectedPayments, accounted);
            setPayments(prev => prev.map(p => selectedPayments.includes(p.id) ? { ...p, accounted } : p));
            setSelectedPayments([]);
        } catch {
            // hata durumunda sessizce bırak
        } finally {
            setBulkAccountingLoading(false);
        }
    };
    const isAllSelected = payments.length > 0 && selectedPayments.length === payments.length;
    const toggleSelectAll = () => {
        if (isAllSelected) {
            setSelectedPayments([]);
        } else {
            setSelectedPayments(payments.map(p => p.id));
        }
    };
    // İade sonrası listeyi mevcut filtrelerle tazele
    const refreshAfterRefund = () => {
        fetchPayments(currentPage, pageSize, appliedFilters);
    };

    const filteredAccounts = companyFilter
        ? accounts.filter(account => account.companyId === companyFilter)
        : accounts;

    const updateUrlParams = useCallback((filters, { page, size, detail } = {}) => {
        const state = {
            page: page ?? currentPage,
            size: size ?? pageSize,
            ...filters,
            // Açık detay paneli URL'de taşınır: tam detay sayfasından geri dönünce
            // panel aynı ödemeyle yeniden açılsın diye.
            detail: detail !== undefined ? detail : (detailPayment?.id || ""),
        };
        const params = new URLSearchParams();
        Object.entries(state).forEach(([key, value]) => {
            if (value !== "" && value !== null && value !== undefined && value !== 0 && !(key === "page" && value === 0) && !(key === "size" && value === 10)) {
                params.set(key, String(value));
            }
        });
        setSearchParams(params, { replace: true });
    }, [currentPage, pageSize, detailPayment, setSearchParams]);

    // API calls — filtreler her zaman "uygulanmış" snapshot üzerinden gönderilir
    const fetchPayments = async (page = 0, size = 10, filters = appliedFilters, isInitial = false) => {
        try {
            isInitial ? setInitialLoading(true) : setRefreshing(true);
            const f = filters || EMPTY_FILTERS;
            const params = {
                page, size,
                ...(f.searchTerm && { searchTerm: f.searchTerm }),
                ...(f.status && { status: f.status }),
                ...(f.receiptType && { receiptType: f.receiptType }),
                ...(f.paymentSource && { paymentSource: f.paymentSource }),
                ...(f.accountId && { accountId: f.accountId }),
                ...(userFilter && { userId: userFilter }),
                ...(f.companyId && isSuperAdmin() && { companyId: f.companyId }),
                ...(f.startDate && { startDate: f.startDate }),
                ...(f.endDate && { endDate: f.endDate }),
                ...(f.accounted !== "" && { accounted: f.accounted }),
            };

            const data = await fetchPaymentHistory(params);

            if (data.statusCode === 200) {
                const { content, totalElements, totalPages, page: cp, size: ps, totalSuccessfulAmount, totalPendingAmount, totalFailedAmount, installmentTransactions, singleTransactions } = data.data;
                setPayments(content);
                setTotalElements(totalElements);
                setTotalPages(totalPages);
                setCurrentPage(cp);
                setPageSize(ps);
                setTotalSuccessfulAmount(totalSuccessfulAmount || 0);
                setTotalPendingAmount(totalPendingAmount || 0);
                setTotalFailedAmount(totalFailedAmount || 0);
                setInstallmentTransactions(installmentTransactions || 0);
                setSingleTransactions(singleTransactions || 0);
                setSelectedPayments([]);
            } else {
                setError(`${pw.Plural} getirilemedi`);
            }
        } catch (err) {
            console.error(err);
            setError(err.message || `${pw.Plural} getirilirken hata`);
        } finally {
            isInitial ? setInitialLoading(false) : setRefreshing(false);
        }
    };

    const fetchCompanies = async () => {
        if (isSuperAdmin()) {
            try {
                const response = await fetchCompaniesList();
                if (response.ok) {
                    const { data } = await response.json();
                    setCompanies(data || []);
                }
            } catch (error) {
                console.error("Firma listesi alınamadı:", error);
            }
        }
    };

    const fetchUserInfo = async () => {
        try {
            const response = await fetchAuthMe();

            if (response.ok) {
                const { data } = await response.json();
                setCurrentUser(data);
            }
        } catch (error) {
            console.error("User info error:", error);
        }
    };

    const fetchAccounts = async () => {
        try {
            if (!currentUser) return;

            const isAccountRole = currentUser.roles?.some(role =>
                role === "ROLE_ACCOUNT_ADMIN" || role === "ROLE_ACCOUNT_ACCOUNTANT"
            );

            if (isAccountRole) return;

            const response = await fetchAccountsMe();

            if (response.ok) {
                const { data } = await response.json();
                setAccounts(data);
            }
        } catch (error) {
            console.error("Accounts fetch error:", error);
        }
    };

    const handleGenerateReport = async () => {
        // Rapor uygulanmış filtrelerdeki kayıtlardan üretilir; kayıt yokken istek boş
        // dosya indiriyor ve kullanıcı neden boş olduğunu göremiyordu.
        if (totalElements === 0) {
            setError(`Seçili filtrelerde ${pw.word} kaydı bulunamadı, rapor oluşturulamadı.`);
            return;
        }
        setExporting(true);
        try {
            const f = appliedFilters;
            const params = {
                page: currentPage,
                size: pageSize,
                ...(f.searchTerm && { searchTerm: f.searchTerm }),
                ...(f.status && { status: f.status }),
                ...(f.receiptType && { receiptType: f.receiptType }),
                ...(f.paymentSource && { paymentSource: f.paymentSource }),
                ...(f.accountId && { accountId: f.accountId }),
                ...(userFilter && { userId: userFilter }),
                ...(f.companyId && isSuperAdmin() && { companyId: f.companyId }),
                ...(f.startDate && { startDate: f.startDate }),
                ...(f.endDate && { endDate: f.endDate }),
                downloadExcel: true
            };

            const blob = await downloadPaymentHistoryExcel(params);
            const now = new Date();
            const formatted = now.toISOString().replace(/[:.]/g, "-");
            const fileName = `TC_${formatted}_odeme_gecmisi.xlsx`;

            const href = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = href;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(href);
        } catch (e) {
            console.error(e);
            setError(e.message || 'Excel dosyası indirilemedi');
        } finally {
            setExporting(false);
        }
    };

    const handleDeletePayments = async (paymentIds) => {
        setDeleteLoading(true);
        try {
            const data = await deletePayments(paymentIds);

            if (data.statusCode === 200) {
                setDeleteSuccess(`${paymentIds.length} ${pw.word} başarıyla silindi.`);
                // Silinen ödeme detay panelinde açıksa paneli kapat
                if (detailPayment && paymentIds.includes(detailPayment.id)) {
                    closeDetail();
                }
                fetchPayments(currentPage, pageSize, appliedFilters);
                setSelectedPayments([]);
            } else {
                throw new Error(data.message || 'Silme işlemi başarısız');
            }
        } catch (error) {
            console.error('Delete error:', error);
            setError(error.message || `${pw.Plural} silinirken hata oluştu`);
        } finally {
            setDeleteLoading(false);
            setDeleteModalOpen(false);
            setPaymentToDelete(null);
            setDeleteType('');
        }
    };

    const handleCopy = async (text, id) => {
        await copyToClipboard(text);
        setCopiedId(id);
        setTimeout(() => setCopiedId(null), 1200);
    };

    /**
     * Makbuz görüntüleme/indirme dekont üretimi paylaşılan modüle taşındı
     * (src/pages/payment/paymentReceipt.js): aynı dekontu tam detay sayfası da
     * üretiyor. Burada yalnızca satır bazlı "indiriliyor" göstergesi yönetiliyor.
     */
    const handleViewReceipt = viewPaymentReceipt;

    const handleDownloadPDF = async (payment) => {
        if (!payment) return;
        setPdfLoading(prev => ({ ...prev, [payment.id]: true }));
        try {
            await downloadPaymentReceiptPdf(payment);
        } finally {
            setPdfLoading(prev => ({ ...prev, [payment.id]: false }));
        }
    };

    // Event handlers
    const openDeleteModal = (type, payment = null) => {
        setDeleteType(type);
        setPaymentToDelete(payment);
        setDeleteModalOpen(true);
        setDeleteSuccess(null);
        setError(null);
    };

    const confirmDelete = () => {
        if (deleteType === 'single' && paymentToDelete) {
            handleDeletePayments([paymentToDelete.id]);
        } else if (deleteType === 'bulk' && selectedPayments.length > 0) {
            handleDeletePayments(selectedPayments);
        }
    };

    // Aynı satıra tekrar tıklanırsa detay paneli kapanır
    const toggleDetail = (payment) => {
        const next = detailPayment && detailPayment.id === payment.id ? null : payment;
        setDetailPayment(next);
        updateUrlParams(appliedFilters, { detail: next ? next.id : "" });
    };

    const closeDetail = () => {
        setDetailPayment(null);
        updateUrlParams(appliedFilters, { detail: "" });
    };

    const handleSelectPayment = (paymentId) => {
        setSelectedPayments(prev => {
            if (prev.includes(paymentId)) {
                return prev.filter(id => id !== paymentId);
            } else {
                return [...prev, paymentId];
            }
        });
    };

    /**
     * Filtreleri uygula. Seçim yapıldığı anda çalışır; state güncellemeleri asenkron
     * olduğu için değişen alan `patch` ile birlikte geçilir.
     */
    /**
     * Hızlı dönem filtreleri. Tarih kutuları datetime-local olduğu için değerler
     * "YYYY-AA-GGTss:dd" biçiminde üretilir; gün başı 00:00, gün sonu 23:59.
     * Hafta pazartesi başlar (TR takvimi) — JS'te pazar 0 olduğu için kaydırılır.
     */
    const localDt = (d, endOfDay = false) => {
        const pad = (n) => String(n).padStart(2, "0");
        const time = endOfDay ? "23:59" : "00:00";
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${time}`;
    };

    const PERIODS = [
        {
            key: "today", label: "Bugün", range: () => {
                const n = new Date();
                return [localDt(n), localDt(n, true)];
            },
        },
        {
            key: "week", label: "Bu Hafta", range: () => {
                const n = new Date();
                const start = new Date(n);
                start.setDate(n.getDate() - ((n.getDay() + 6) % 7));   // pazartesi
                return [localDt(start), localDt(n, true)];
            },
        },
        {
            key: "month", label: "Bu Ay", range: () => {
                const n = new Date();
                return [localDt(new Date(n.getFullYear(), n.getMonth(), 1)), localDt(n, true)];
            },
        },
    ];

    /** Seçili dönem, uygulanmış tarih aralığı hangi hazır aralıkla birebir eşleşiyorsa odur. */
    const activePeriod = PERIODS.find((prd) => {
        const [s2, e2] = prd.range();
        return appliedFilters.startDate === s2 && appliedFilters.endDate === e2;
    })?.key || "";

    const applyPeriod = (key) => {
        const prd = PERIODS.find((x) => x.key === key);
        if (!prd) return;
        // Aynı düğmeye tekrar basmak dönem filtresini kaldırır.
        const [s2, e2] = activePeriod === key ? ["", ""] : prd.range();
        setStartDate(s2);
        setEndDate(e2);
        applyFilters({ startDate: s2, endDate: e2 });
    };

    /** Taksit dağılımı yüzdesi. Hiç başarılı işlem yoksa 0 döner (0'a bölme yok). */
    const pctOf = (n) => {
        const total = installmentTransactions + singleTransactions;
        return total > 0 ? Math.round((n / total) * 100) : 0;
    };

    const applyFilters = (patch = {}) => {
        const filters = { ...draftFilters(), ...patch };
        setAppliedFilters(filters);
        setCurrentPage(0);
        updateUrlParams(filters, { page: 0 });
        fetchPayments(0, pageSize, filters);
    };

    // Tüm filtreleri temizle ve listeyi filtresiz getir
    const handleClearFilters = () => {
        setSearchTerm("");
        setStatusFilter("");
        setReceiptTypeFilter("");
        setPaymentSourceFilter("");
        setAccountFilter("");
        setCompanyFilter("");
        setStartDate("");
        setEndDate("");
        setAccountedFilter("");
        setAppliedFilters(EMPTY_FILTERS);
        setCurrentPage(0);
        updateUrlParams(EMPTY_FILTERS, { page: 0 });
        fetchPayments(0, pageSize, EMPTY_FILTERS);
    };

    const activeFilterCount = Object.values(appliedFilters).filter(v => v !== "").length;

    const handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < totalPages) {
            setCurrentPage(newPage);
            updateUrlParams(appliedFilters, { page: newPage });
            fetchPayments(newPage, pageSize, appliedFilters);
        }
    };

    const handlePageSizeChange = (size) => {
        setPageSize(size);
        setCurrentPage(0);
        updateUrlParams(appliedFilters, { page: 0, size });
        fetchPayments(0, size, appliedFilters);
    };

    // Effects
    useEffect(() => {
        fetchUserInfo();
    }, []);

    useEffect(() => {
        if (currentUser) {
            fetchCompanies();
            fetchAccounts();
        }
    }, [currentUser]);

    // Arama kutusu: yazma bitince (500ms) otomatik uygulanır
    useEffect(() => {
        if (isFirstSearch.current) {
            isFirstSearch.current = false;
            return;
        }
        const timeout = setTimeout(() => applyFilters({ searchTerm }), 500);
        return () => clearTimeout(timeout);
    }, [searchTerm]);

    // Initial data fetch — runs once on mount with URL-restored filters
    useEffect(() => {
        fetchPayments(currentPage, pageSize, appliedFilters, true);
    }, []);

    /**
     * Liste her tazelendiğinde detay panelini senkronlar:
     *  - URL'de `detail` varsa (ör. tam detay sayfasından geri dönüldü) paneli yeniden açar
     *  - Açık panelin verisini güncel satırla eşitler
     *  - Ödeme listede yoksa (silindi/filtre dışında kaldı) paneli ve parametreyi temizler
     */
    useEffect(() => {
        // İlk yükleme bitmeden liste boştur; bu aşamada "bulunamadı" kararı verilirse
        // URL'deki detay parametresi veri gelmeden silinir ve panel bir daha açılamaz.
        if (initialLoading) return;

        const urlDetailId = searchParams.get("detail");
        const targetId = detailPayment?.id || urlDetailId;
        if (!targetId) return;

        const fresh = payments.find(p => p.id === targetId);
        if (fresh) {
            setDetailPayment(fresh);
        } else {
            setDetailPayment(null);
            if (urlDetailId) {
                updateUrlParams(appliedFilters, { detail: "" });
            }
        }
    }, [payments, initialLoading]);

    // Otomatik yenileme — filtre, sayfa ve açık detay paneli korunur.
    // fetchPayments'a isInitial=false geçildiği için tam sayfa spinner'ı değil
    // yalnız üstteki "yenileniyor" göstergesi çalışır; appliedFilters o anki
    // uygulanmış filtre anlık görüntüsüdür, yani liste aynı süzgeçle tazelenir.
    // Modal açıkken durur: kullanıcı iade/silme onayı verirken altındaki satır değişmesin.
    const anyModalOpen = refundModalOpen || emailModalOpen || deleteModalOpen;
    const autoRefresh = useAutoRefresh(
        () => fetchPayments(currentPage, pageSize, appliedFilters),
        { intervalMs: AUTO_REFRESH_MS, enabled: !anyModalOpen && !isSessionModalActive }
    );

    // Sağ detay panelinin sticky kalabilmesi için tema kısıtını yalnızca bu sayfada
    // gevşetiyoruz (bkz. Paymenthistorystyles.js — body.payment-history-modern-page).
    useEffect(() => {
        const cls = "payment-history-modern-page";
        document.body.classList.add(cls);
        return () => document.body.classList.remove(cls);
    }, []);

    useEffect(() => {
        if (deleteSuccess) {
            const timer = setTimeout(() => {
                setDeleteSuccess(null);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [deleteSuccess]);

    return (
        <div className="page-content payment-history-modern">
            <style>{getPaymentHistoryStyles()}</style>
            <div className="container-fluid">
                {/* Sayfa başlığı */}
                <div className="mb-3">
                    <h4 className="mb-1 fw-bold">{pw.Word} Geçmişi</h4>
                    <p className="mb-0 text-muted" style={{ fontSize: ".9rem" }}>
                        Tüm {pw.word} hareketlerinizi buradan takip edebilir, raporlayabilir ve yönetebilirsiniz.
                    </p>
                </div>

                {/* Özet kartlar satırın DIŞINDA: detay paneli açıldığında sol kolon
                    daralıyor; kartlar burada kalırsa onlar da daralıp bozuluyordu.
                    Böylece kartlar hep tam genişlik, panel de tablonun hizasından açılır. */}
                <Row className="g-3 mb-3 row-cols-1 row-cols-sm-2 row-cols-xl-5">
                    <Col>
                        <div className={`mini-stat-card ${appliedFilters.status && appliedFilters.status !== 'SUCCESS' ? 'stat-blur' : ''}`}>
                            <div className="mini-stat-icon success"><i className="bx bx-check-circle text-success" /></div>
                            <div>
                                <div className="text-muted small">Başarılı Tahsilat</div>
                                <div className="mini-stat-amount">{formatAmount(totalSuccessfulAmount || 0)}</div>
                                <div className="cell-sub">Toplam başarılı tahsilat</div>
                            </div>
                        </div>
                    </Col>

                    <Col>
                        <div className={`mini-stat-card ${appliedFilters.status && appliedFilters.status !== 'FAILED' ? 'stat-blur' : ''}`}>
                            <div className="mini-stat-icon failed"><i className="bx bx-x-circle text-danger" /></div>
                            <div>
                                <div className="text-muted small">Başarısız İşlem</div>
                                <div className="mini-stat-amount">{formatAmount(totalFailedAmount || 0)}</div>
                                <div className="cell-sub">Toplam başarısız tahsilat</div>
                            </div>
                        </div>
                    </Col>

                    <Col>
                        <div className={`mini-stat-card ${appliedFilters.status && appliedFilters.status !== 'PENDING' ? 'stat-blur' : ''}`}>
                            <div className="mini-stat-icon pending"><i className="bx bx-time-five text-warning" /></div>
                            <div>
                                <div className="text-muted small">Bekleyen</div>
                                <div className="mini-stat-amount">{formatAmount(totalPendingAmount || 0)}</div>
                                <div className="cell-sub">Bekleyen tahsilat</div>
                            </div>
                        </div>
                    </Col>

                    <Col>
                        <div className="mini-stat-card">
                            <div className="mini-stat-icon total"><i className="bx bx-credit-card-front" /></div>
                            <div>
                                <div className="text-muted small">Taksitli İşlem Oranı</div>
                                <div className="mini-stat-amount">%{pctOf(installmentTransactions)}</div>
                                {/* Tek çekim oranı yazılmaz: 100'den çıkarınca zaten çıkar.
                                    Yüzdenin dayandığı sayıyı göstermek daha bilgilendirici. */}
                                <div className="cell-sub">
                                    {installmentTransactions} / {installmentTransactions + singleTransactions} başarılı taksitli işlem
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col>
                        <div className="mini-stat-card">
                            <div className="mini-stat-icon total"><i className="bx bx-layer" /></div>
                            <div>
                                <div className="text-muted small">Toplam İşlem</div>
                                <div className="mini-stat-amount">{totalElements}</div>
                                <div className="cell-sub">Toplam {pw.word} sayısı</div>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className="g-3">
                    {/* Liste — detay paneli açıkken daralır */}
                    <Col xl={detailPayment ? 8 : 12} xxl={detailPayment ? 9 : 12} className="ph-main">
                        <TableCard data-tour="payment-history-card">
                            <CardHeader className="bg-white border-0 rounded-top-4" data-tour="payment-history-header">
                                {/* Filtre alanı — seçim yapıldığı anda liste güncellenir */}
                                <div className="filter-bar">
                                    <div className="d-flex flex-wrap gap-2">
                                        <div className="filter-field">
                                            <span className="filter-label">Arama</span>
                                            <Input
                                                type="search"
                                                placeholder="İşlem kodu, müşteri, e-posta ara..."
                                                value={searchTerm}
                                                onChange={e => setSearchTerm(e.target.value)}
                                                onKeyDown={e => { if (e.key === "Enter") applyFilters({ searchTerm: e.target.value }); }}
                                                className="pill-input"
                                            />
                                        </div>

                                        <div className="filter-field">
                                            <span className="filter-label">Başlangıç</span>
                                            <DateTimeInput
                                                value={startDate}
                                                onChange={v => { setStartDate(v); applyFilters({ startDate: v }); }}
                                                className="pill-input"
                                            />
                                        </div>

                                        <div className="filter-field">
                                            <span className="filter-label">Bitiş</span>
                                            <DateTimeInput
                                                value={endDate}
                                                onChange={v => { setEndDate(v); applyFilters({ endDate: v }); }}
                                                className="pill-input"
                                            />
                                        </div>

                                        <div className="filter-field">
                                            <span className="filter-label">Durum</span>
                                            <Input
                                                type="select"
                                                value={statusFilter}
                                                onChange={e => { setStatusFilter(e.target.value); applyFilters({ status: e.target.value }); }}
                                                className="pill-select"
                                            >
                                                <option value="">Tümü</option>
                                                <option value="SUCCESS">Başarılı</option>
                                                <option value="PENDING">Beklemede</option>
                                                <option value="FAILED">Başarısız</option>
                                                <option value="REFUNDED">İade Edildi</option>
                                                <option value="PARTIALLY_REFUNDED">Kısmi İade</option>
                                            </Input>
                                        </div>

                                        <div className="filter-field">
                                            <span className="filter-label">{pw.Word} Yöntemi</span>
                                            <Input
                                                type="select"
                                                value={receiptTypeFilter}
                                                onChange={e => { setReceiptTypeFilter(e.target.value); applyFilters({ receiptType: e.target.value }); }}
                                                className="pill-select"
                                            >
                                                <option value="">Tümü</option>
                                                {PAYMENT_METHOD_GROUPS.map(m => (
                                                    <option key={m.key} value={m.key}>{m.label}</option>
                                                ))}
                                            </Input>
                                        </div>

                                        <div className="filter-field">
                                            <span className="filter-label">Tahsilat Tipi</span>
                                            <Input
                                                type="select"
                                                value={paymentSourceFilter}
                                                onChange={e => { setPaymentSourceFilter(e.target.value); applyFilters({ paymentSource: e.target.value }); }}
                                                className="pill-select"
                                            >
                                                <option value="">Tümü</option>
                                                {PAYMENT_SOURCES.map(s => (
                                                    <option key={s.key} value={s.key}>{s.label}</option>
                                                ))}
                                            </Input>
                                        </div>
                                    </div>

                                    <Collapse isOpen={filtersOpen}>
                                        <div className="d-flex flex-wrap gap-2 mt-2">
                                            {isSuperAdmin() && (
                                                <div className="filter-field">
                                                    <span className="filter-label">Firma</span>
                                                    <Input
                                                        type="select"
                                                        value={companyFilter}
                                                        onChange={e => { setCompanyFilter(e.target.value); setAccountFilter(""); applyFilters({ companyId: e.target.value, accountId: "" }); }}
                                                        className="pill-select"
                                                    >
                                                        <option value="">Tümü</option>
                                                        {companies.map(c => (
                                                            <option key={c.id} value={c.id}>{c.companyName}</option>
                                                        ))}
                                                    </Input>
                                                </div>
                                            )}

                                            {currentUser && !currentUser.roles?.some(role =>
                                                role === "ROLE_ACCOUNT_ADMIN" || role === "ROLE_ACCOUNT_ACCOUNTANT"
                                            ) && filteredAccounts.length > 0 && (
                                                <div className="filter-field">
                                                    <span className="filter-label">Cari</span>
                                                    <Input
                                                        type="select"
                                                        value={accountFilter}
                                                        onChange={e => { setAccountFilter(e.target.value); applyFilters({ accountId: e.target.value }); }}
                                                        className="pill-select"
                                                    >
                                                        <option value="">Tümü</option>
                                                        {filteredAccounts.map(acc => (
                                                            <option key={acc.id} value={acc.id}>
                                                                {acc.accountCode} - {acc.accountName}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </div>
                                            )}

                                            {canToggleAccounted() && (
                                                <div className="filter-field">
                                                    <span className="filter-label">Muhasebe</span>
                                                    <Input
                                                        type="select"
                                                        value={accountedFilter}
                                                        onChange={e => { setAccountedFilter(e.target.value); applyFilters({ accounted: e.target.value }); }}
                                                        className="pill-select"
                                                    >
                                                        <option value="">Tümü</option>
                                                        <option value="true">Muhasebeleşti</option>
                                                        <option value="false">Muhasebeleşmedi</option>
                                                    </Input>
                                                </div>
                                            )}
                                        </div>
                                    </Collapse>

                                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-3 filter-actions">
                                        <button
                                            type="button"
                                            className="btn btn-link text-decoration-none p-0"
                                            style={{ color: COLORS.NAVY, height: "auto" }}
                                            onClick={() => setFiltersOpen(v => !v)}
                                        >
                                            <i className={`bx ${filtersOpen ? 'bx-chevron-up' : 'bx-filter-alt'} me-1`} />
                                            Gelişmiş Filtreler
                                        </button>

                                        <div className="d-flex align-items-center gap-2 flex-wrap">
                                            {activeFilterCount > 0 && (
                                                <span className="chip chip-navy">{activeFilterCount} filtre aktif</span>
                                            )}
                                            <Button
                                                color="light"
                                                className="btn-rounded"
                                                onClick={handleClearFilters}
                                                disabled={activeFilterCount === 0}
                                            >
                                                <i className="bx bx-x me-1" /> Temizle
                                            </Button>
                                        </div>
                                    </div>
                                </div>

                                {/* Araç çubuğu */}
                                <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-3">
                                    <div className="d-flex align-items-center gap-2">
                                        {(isSuperAdmin() || canToggleAccounted()) && payments.length > 0 && (
                                            <label className="d-flex align-items-center gap-2 mb-0 text-muted small" style={{ cursor: "pointer" }}>
                                                <Input
                                                    type="checkbox"
                                                    className="m-0"
                                                    checked={isAllSelected}
                                                    onChange={toggleSelectAll}
                                                />
                                                Tümünü Seç ({selectedPayments.length})
                                            </label>
                                        )}
                                    </div>

                                    <div className="d-flex flex-wrap align-items-center gap-2 toolbar-actions">
                                        {/* Hızlı dönem — Rapor Oluştur'un yanında.
                                            Seçili düğmeye tekrar basmak aralığı temizler. */}
                                        <div className="d-flex bg-white p-1 period-pills" style={{ borderRadius: 999, border: "1px solid #e7eaf0" }}>
                                            {PERIODS.map((prd) => (
                                                <button
                                                    key={prd.key}
                                                    type="button"
                                                    onClick={() => applyPeriod(prd.key)}
                                                    className={`btn btn-sm px-3 period-pill ${activePeriod === prd.key ? "is-active" : ""}`}
                                                >
                                                    {prd.label}
                                                </button>
                                            ))}
                                        </div>

                                        <Button
                                            onClick={handleGenerateReport}
                                            disabled={exporting || initialLoading || totalElements === 0}
                                            className="d-flex align-items-center gap-1 btn-rounded btn-navy-outline"
                                            title={totalElements === 0
                                                ? `Seçili filtrelerde ${pw.word} kaydı yok`
                                                : "Filtrelenmiş tüm kayıtları Excel olarak indirir"}
                                        >
                                            {exporting
                                                ? <Spinner size="sm" style={{ width: 14, height: 14 }} />
                                                : <i className="bx bx-file" />}
                                            {" "}Rapor Oluştur
                                        </Button>

                                        {/* İade Geçmişi finansal denetim ekranıdır; erişim
                                            iade YAPMA yetkisiyle aynı rollerle sınırlıdır. */}
                                        {canRefund() && (
                                            <Button
                                                onClick={() => navigate("/refund-history")}
                                                className="d-flex align-items-center gap-1 btn-rounded btn-navy-outline"
                                                title="Tüm sanal POS iadelerini görüntüle"
                                            >
                                                <i className="bx bx-undo" />{" "}İade Geçmişi
                                            </Button>
                                        )}

                                        {(isSuperAdmin() || canToggleAccounted()) && (
                                            <UncontrolledDropdown>
                                                <DropdownToggle
                                                    caret
                                                    className="btn-rounded btn-navy d-flex align-items-center gap-1"
                                                    disabled={selectedPayments.length === 0 || bulkAccountingLoading}
                                                >
                                                    {bulkAccountingLoading
                                                        ? <Spinner size="sm" style={{ width: 14, height: 14 }} />
                                                        : <i className="bx bx-list-check" />}
                                                    {" "}Toplu İşlemler
                                                </DropdownToggle>
                                                <DropdownMenu end>
                                                    {canToggleAccounted() && (
                                                        <>
                                                            <DropdownItem onClick={() => handleBulkAccounted(true)}>
                                                                <i className="bx bx-check-circle me-1 text-success" />
                                                                Muhasebeleşti işaretle ({selectedPayments.length})
                                                            </DropdownItem>
                                                            <DropdownItem onClick={() => handleBulkAccounted(false)}>
                                                                <i className="bx bx-circle me-1 text-muted" />
                                                                Muhasebeleşmedi işaretle ({selectedPayments.length})
                                                            </DropdownItem>
                                                        </>
                                                    )}
                                                    {isSuperAdmin() && (
                                                        <>
                                                            <DropdownItem divider />
                                                            <DropdownItem className="text-danger" onClick={() => openDeleteModal('bulk')}>
                                                                <i className="bx bx-trash me-1" />
                                                                Seçilenleri Sil ({selectedPayments.length})
                                                            </DropdownItem>
                                                        </>
                                                    )}
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        )}
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody className="pt-2">
                                {error && (
                                    <Alert color="danger" className="mb-3 rounded-4">
                                        <i className="bx bx-error-circle me-2" />
                                        {error}
                                    </Alert>
                                )}

                                {deleteSuccess && (
                                    <Alert color="success" className="mb-3 rounded-4">
                                        <i className="bx bx-check-circle me-2" />
                                        {deleteSuccess}
                                    </Alert>
                                )}

                                {initialLoading ? (
                                    <div className="text-center p-5">
                                        <Spinner size="lg" color="primary" />
                                        <h6 className="mt-3 text-muted">{pw.Plural} yükleniyor...</h6>
                                    </div>
                                ) : (
                                    <>
                                        <div className={`d-flex justify-content-between align-items-center mb-3 ${refreshing ? 'opacity-50' : ''}`}>
                                            <div className="text-muted small d-flex align-items-center flex-wrap gap-2">
                                                {totalElements > 0 && (
                                                    <span>Toplam <strong>{totalElements}</strong> {pw.word} • Sayfa <strong>{currentPage + 1}</strong> / {totalPages}</span>
                                                )}
                                                <RefreshIndicator
                                                    refreshing={refreshing || autoRefresh.refreshing}
                                                    lastRefreshedAt={autoRefresh.lastRefreshedAt}
                                                />
                                            </div>
                                            <button
                                                className="btn btn-light btn-sm btn-rounded"
                                                onClick={() => fetchPayments(currentPage, pageSize, appliedFilters)}
                                                title="Yenile"
                                            >
                                                <i className={`bx bx-refresh ${refreshing ? 'bx-spin' : ''}`} />
                                            </button>
                                        </div>

                                        <div className="table-responsive rounded-4 border">
                                            <Table className="table table-hover mb-0">
                                                <Thead>
                                                    <Tr>
                                                        {(isSuperAdmin() || canToggleAccounted()) && <Th style={{ width: 40 }} />}
                                                        <Th>İşlem No / Tarih</Th>
                                                        <Th className="d-none d-sm-table-cell">Müşteri / Firma</Th>
                                                        <Th className="d-none d-lg-table-cell text-center">Tahsilat Tipi</Th>
                                                        <Th className="d-none d-lg-table-cell text-center">{pw.Word} Yöntemi</Th>
                                                        <Th className="text-center">Tutar</Th>
                                                        <Th className="text-center">Durum</Th>
                                                        {canToggleAccounted() && <Th className="d-none d-md-table-cell text-center">Muhasebe</Th>}
                                                        <Th className="text-center">İşlemler</Th>
                                                    </Tr>
                                                </Thead>
                                                <Tbody>
                                                    {payments && payments.length ? payments.map(p => (
                                                        <Tr
                                                            key={p.id}
                                                            className={`border-bottom row-clickable ${detailPayment?.id === p.id ? "row-selected" : ""}`}
                                                            onClick={() => toggleDetail(p)}
                                                        >
                                                            {(isSuperAdmin() || canToggleAccounted()) && (
                                                                <Td onClick={e => e.stopPropagation()}>
                                                                    <Input
                                                                        type="checkbox"
                                                                        checked={selectedPayments.includes(p.id)}
                                                                        onChange={() => handleSelectPayment(p.id)}
                                                                    />
                                                                </Td>
                                                            )}

                                                            <Td>
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <span className="fw-semibold text-dark">{p.merchantOid}</span>
                                                                    <button
                                                                        className="btn btn-sm btn-link p-0 text-info"
                                                                        onClick={e => { e.stopPropagation(); handleCopy(p.merchantOid, p.id); }}
                                                                        title="Kopyala"
                                                                    >
                                                                        <i className={`bx ${copiedId === p.id ? 'bx-check text-success' : 'bx-copy'}`} />
                                                                    </button>
                                                                </div>
                                                                <div className="cell-sub">{formatDateTime(p.paymentDate)}</div>
                                                            </Td>

                                                            <Td className="d-none d-sm-table-cell">
                                                                <TruncatedText
                                                                    text={p.userNameSnapshot || "Misafir"}
                                                                    maxLength={20}
                                                                    className="fw-semibold text-dark"
                                                                />
                                                                <div className="cell-sub">
                                                                    <TruncatedText text={p.emailSnapshot || "-"} maxLength={26} />
                                                                </div>
                                                                <div className="cell-sub" style={{ color: COLORS.NAVY }}>
                                                                    <TruncatedText text={p.companyName || "Belirtilmemiş"} maxLength={26} />
                                                                </div>
                                                            </Td>

                                                            <Td className="d-none d-lg-table-cell text-center">
                                                                <CollectionTypeChip payment={p} />
                                                            </Td>
                                                            <Td className="d-none d-lg-table-cell text-center">
                                                                {p.receiptType && (
                                                                    <span className="chip chip-gray">{getReceiptTypeText(p.receiptType)}</span>
                                                                )}
                                                            </Td>

                                                            <Td className="text-center text-nowrap"><strong>{formatAmount(p.amount)}</strong></Td>

                                                            <Td className="text-center">
                                                                <span className={`chip ${statusToChipClass(p.status)}`}>
                                                                    {getPaymentStatusText(p.status)}
                                                                </span>
                                                                {/* Başarısız satırda tek satırlık gerekçe özeti: kullanıcı listeden
                                                                    çıkmadan neden başarısız olduğunu görsün. Tam metin ve teknik
                                                                    kod detay panelinde/sayfasında. */}
                                                                {p.status === "FAILED" && (p.failureUserMessage || p.failedReasonMsg) && (
                                                                    <div className="cell-sub status-reason text-danger" title={p.failureUserMessage || p.failedReasonMsg}>
                                                                        <TruncatedText
                                                                            text={p.failureUserMessage || p.failedReasonMsg}
                                                                            maxLength={34}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </Td>

                                                            {canToggleAccounted() && (
                                                                <Td className="d-none d-md-table-cell text-center" onClick={e => e.stopPropagation()}>
                                                                    <button
                                                                        className={`chip ${p.accounted ? "chip-green" : "chip-gray"}`}
                                                                        style={{
                                                                            cursor: accountingLoading[p.id] ? "wait" : p.status !== "SUCCESS" ? "not-allowed" : "pointer",
                                                                            opacity: p.status !== "SUCCESS" ? 0.45 : 1,
                                                                        }}
                                                                        onClick={() => handleToggleAccounted(p)}
                                                                        disabled={accountingLoading[p.id] || p.status !== "SUCCESS"}
                                                                        title={p.status !== "SUCCESS" ? `Sadece başarılı ${pw.plural}` : (p.accounted ? "Muhasebeleşmedi olarak işaretle" : "Muhasebeleşti olarak işaretle")}
                                                                    >
                                                                        {accountingLoading[p.id] ? (
                                                                            <Spinner size="sm" style={{ width: 12, height: 12 }} />
                                                                        ) : (
                                                                            <>
                                                                                <i className={`bx ${p.accounted ? "bx-check-circle" : "bx-circle"} me-1`} />
                                                                                {p.accounted ? "Evet" : "Hayır"}
                                                                            </>
                                                                        )}
                                                                    </button>
                                                                </Td>
                                                            )}

                                                            <Td className="text-center" onClick={e => e.stopPropagation()}>
                                                                <UncontrolledDropdown>
                                                                    {/* İkon-only: kolon başlığı zaten "İşlemler" diyor, buton
                                                                        metni satırda yer kaplıyordu. Caret de kaldırıldı;
                                                                        menü ikonu açılır menüyü kendi başına anlatıyor. */}
                                                                    <DropdownToggle
                                                                        size="sm"
                                                                        className="btn-actions-menu"
                                                                        title="İşlemler"
                                                                        aria-label="İşlemler"
                                                                    >
                                                                        <i className="bx bx-menu" />
                                                                    </DropdownToggle>
                                                                    <DropdownMenu end>
                                                                        <DropdownItem onClick={() => toggleDetail(p)}>
                                                                            <i className="bx bx-show me-1" />
                                                                            {detailPayment?.id === p.id ? " Detayı Kapat" : " Detay"}
                                                                        </DropdownItem>
                                                                        <DropdownItem onClick={() => handleViewReceipt(p)}>
                                                                            <i className="bx bx-receipt me-1" /> Makbuz Görüntüle
                                                                        </DropdownItem>
                                                                        <DropdownItem
                                                                            onClick={() => handleDownloadPDF(p)}
                                                                            disabled={pdfLoading[p.id]}
                                                                        >
                                                                            <i className="bx bx-download me-1" /> Makbuz İndir
                                                                        </DropdownItem>
                                                                        <DropdownItem onClick={() => { setEmailTarget(p); setEmailModalOpen(true); }}>
                                                                            <i className="bx bx-envelope me-1" /> Makbuzu E-posta Gönder
                                                                        </DropdownItem>
                                                                        {canRefund() && isRefundable(p) && (
                                                                            <DropdownItem onClick={() => { setRefundTarget(p); setRefundModalOpen(true); }}>
                                                                                <i className="bx bx-undo me-1" /> Tutar İadesi
                                                                            </DropdownItem>
                                                                        )}
                                                                        {isSuperAdmin() && (
                                                                            <>
                                                                                <DropdownItem divider />
                                                                                <DropdownItem className="text-danger" onClick={() => openDeleteModal('single', p)}>
                                                                                    <i className="bx bx-trash me-1" /> Sil
                                                                                </DropdownItem>
                                                                            </>
                                                                        )}
                                                                    </DropdownMenu>
                                                                </UncontrolledDropdown>
                                                            </Td>
                                                        </Tr>
                                                    )) : (
                                                        <Tr>
                                                            <Td colSpan={20} className="text-center py-5">
                                                                <div className="text-muted">
                                                                    <i className="bx bx-credit-card display-4 d-block mb-2" />
                                                                    {pw.Word} bulunamadı
                                                                    {activeFilterCount > 0 && (
                                                                        <div className="mt-2"><small>Filtreleri temizlemeyi deneyin</small></div>
                                                                    )}
                                                                </div>
                                                            </Td>
                                                        </Tr>
                                                    )}
                                                </Tbody>
                                            </Table>
                                        </div>

                                        {totalElements > 0 && (
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="text-muted small">
                                                    {totalElements} {pw.ablative} {currentPage * pageSize + 1} - {Math.min((currentPage + 1) * pageSize, totalElements)} arası gösteriliyor
                                                    {selectedPayments.length > 0 && (isSuperAdmin() || canToggleAccounted()) && (
                                                        <span className="ms-3 text-primary">
                              <i className="bx bx-check-square me-1" />
                                                            {selectedPayments.length} {pw.word} seçildi
                            </span>
                                                    )}
                                                </div>
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="d-flex align-items-center gap-2">
                                                        <span className="text-muted small">Sayfa başına</span>
                                                        <select
                                                            className="form-select form-select-sm rounded-pill page-size-select"
                                                            value={pageSize}
                                                            onChange={e => handlePageSizeChange(parseInt(e.target.value))}
                                                            style={{ width: "auto" }}
                                                        >
                                                            {DEFAULT_PAGE_SIZES.map(s => (
                                                                <option key={s} value={s}>{s}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <nav>
                                                        <ul className="pagination pagination-sm mb-0 corporate-pagination">
                                                            <li className={`page-item ${currentPage === 0 ? "disabled" : ""}`}>
                                                                <button
                                                                    className="page-link"
                                                                    onClick={() => handlePageChange(currentPage - 1)}
                                                                    disabled={currentPage === 0}
                                                                >
                                                                    <i className="bx bx-chevron-left" />
                                                                </button>
                                                            </li>
                                                            {getPaginationNumbers(currentPage, totalPages).map(p => (
                                                                <li key={p} className={`page-item ${currentPage === p ? "active" : ""}`}>
                                                                    <button
                                                                        className="page-link"
                                                                        onClick={() => handlePageChange(p)}
                                                                    >
                                                                        {p + 1}
                                                                    </button>
                                                                </li>
                                                            ))}
                                                            <li className={`page-item ${currentPage >= totalPages - 1 ? "disabled" : ""}`}>
                                                                <button
                                                                    className="page-link"
                                                                    onClick={() => handlePageChange(currentPage + 1)}
                                                                    disabled={currentPage >= totalPages - 1}
                                                                >
                                                                    <i className="bx bx-chevron-right" />
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </nav>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </CardBody>

                            <PaymentRefundModal
                                isOpen={refundModalOpen}
                                toggle={() => { setRefundModalOpen(false); setRefundTarget(null); }}
                                payment={refundTarget}
                                onConfirm={refreshAfterRefund}
                            />

                            <PaymentReceiptEmailModal
                                isOpen={emailModalOpen}
                                toggle={() => { setEmailModalOpen(false); setEmailTarget(null); }}
                                payment={emailTarget}
                            />

                            <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(false)} centered>
                                <ModalHeader toggle={() => setDeleteModalOpen(false)}>
                                    <i className="bx bx-trash text-danger me-2" />
                                    {pw.Word} Silme Onayı
                                </ModalHeader>
                                <ModalBody>
                                    <div className="text-center">
                                        <div className="mb-3">
                                            <i className="bx bx-error-circle text-warning" style={{ fontSize: '48px' }} />
                                        </div>
                                        {deleteType === 'single' && paymentToDelete ? (
                                            <div>
                                                <h5 className="mb-3">Bu {pw.accusative} silmek istediğinizden emin misiniz?</h5>
                                                <div className="bg-light p-3 rounded mb-3">
                                                    <div className="text-start small">
                                                        <p className="mb-1"><strong>İşlem Kodu:</strong> {paymentToDelete.merchantOid}</p>
                                                        <p className="mb-1"><strong>Tutar:</strong> {formatAmount(paymentToDelete.amount)}</p>
                                                        <p className="mb-1"><strong>Kullanıcı:</strong> {paymentToDelete.userNameSnapshot || 'Misafir'}</p>
                                                        <p className="mb-0"><strong>Tarih:</strong> {formatDateTime(paymentToDelete.paymentDate)}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : deleteType === 'bulk' ? (
                                            <div>
                                                <h5 className="mb-3">Seçilen {selectedPayments.length} {pw.accusative} silmek istediğinizden emin misiniz?</h5>
                                                <div className="bg-light p-3 rounded mb-3">
                                                    <strong>{selectedPayments.length} {pw.word} kalıcı olarak silinecektir.</strong>
                                                </div>
                                            </div>
                                        ) : null}
                                        <p className="text-muted small mt-3">
                                            <strong>Dikkat:</strong> Bu işlem geri alınamaz.
                                        </p>
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <Button
                                        color="secondary"
                                        onClick={() => setDeleteModalOpen(false)}
                                        disabled={deleteLoading}
                                    >
                                        İptal
                                    </Button>
                                    <Button
                                        color="danger"
                                        onClick={confirmDelete}
                                        disabled={deleteLoading}
                                    >
                                        {deleteLoading ? (
                                            <>
                                                <Spinner size="sm" className="me-2" />
                                                Siliniyor...
                                            </>
                                        ) : (
                                            <>
                                                <i className="bx bx-trash me-1" />
                                                Sil
                                            </>
                                        )}
                                    </Button>
                                </ModalFooter>
                            </Modal>
                        </TableCard>
                    </Col>

                    {/* Seçilen ödemenin detay paneli — xl'de sağda sabit, altında sağdan açılan overlay */}
                    {detailPayment && (
                        <>
                            <div className="pd-backdrop d-xl-none" onClick={closeDetail} />
                            <Col xl={4} xxl={3} className="ph-side">
                                <PaymentDetailPanel
                                    payment={detailPayment}
                                    words={pw}
                                    onClose={closeDetail}
                                    pdfLoading={!!pdfLoading[detailPayment.id]}
                                    accountingLoading={!!accountingLoading[detailPayment.id]}
                                    permissions={{
                                        canToggleAccounted: canToggleAccounted(),
                                        canRefund: canRefund(),
                                        isRefundable: isRefundable(detailPayment),
                                        isSuperAdmin: isSuperAdmin(),
                                    }}
                                    actions={{
                                        onViewReceipt: handleViewReceipt,
                                        onDownloadPdf: handleDownloadPDF,
                                        onSendEmail: (p) => { setEmailTarget(p); setEmailModalOpen(true); },
                                        onToggleAccounted: async (p) => {
                                            await handleToggleAccounted(p);
                                            setDetailPayment(prev => prev && prev.id === p.id
                                                ? { ...prev, accounted: !p.accounted }
                                                : prev);
                                        },
                                        onRefund: (p) => { setRefundTarget(p); setRefundModalOpen(true); },
                                        onDelete: (p) => openDeleteModal('single', p),
                                        onOpenFullDetail: (p) => navigate(`/payment/${p.id}`, { state: { payment: p } }),
                                    }}
                                />
                            </Col>
                        </>
                    )}
                </Row>
            </div>
        </div>
    );
};

PaymentHistoryTable.propTypes = {
    isSessionModalActive: PropTypes.bool
};

const mapStateToProps = state => ({
    isSessionModalActive: state.Login.isSessionModalActive
});

export default connect(mapStateToProps)(PaymentHistoryTable);